import ComboBoxItem from "components/ComboBox/ComboBoxItem";

const CURRENT_REVENUE: ComboBoxItem<string>[] = [
  { id: 0, label: "None, in the midst of Ideation and R&D", value: "None" },
  { id: 1, label: "SGD 0-100", value: "SGD 0-100" },
  { id: 2, label: "SGD 101-1000", value: "SGD 101-1000" },
  { id: 3, label: "SGD 1001-10000", value: "SGD 1001-10000" },
  { id: 4, label: "SGD >10000", value: "SGD >10000" },
];

export default CURRENT_REVENUE;
